module.exports = __webpack_public_path__ + "img/nlg.a879b0cc.svg";